import React, { useState } from 'react';
import './NegativeInterestBuilder.css';

const NegativeInterestBuilder = ({
    negativeInterests = [],
    onAdd,
    onRemove,
    disabled = false,
    maxInterests = 5
}) => {
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleInputKeyDown = (e) => {
        if (e.key === 'Enter' && inputValue.trim()) {
            e.preventDefault();
            addInterest(inputValue.trim());
        } else if (e.key === 'Escape') {
            setInputValue('');
        }
    };

    const addInterest = (interest) => {
        if (negativeInterests.length >= maxInterests) {
            return; // Don't add if at max
        }

        if (interest && !negativeInterests.includes(interest)) {
            onAdd(interest);
            setInputValue('');
        }
    };

    const removeInterest = (interest) => {
        onRemove(interest);
    };

    return (
        <div className="negative-interest-builder">
            <div className="negative-interest-builder-header">
                <label className="negative-interest-builder-label">
                    <span className="negative-interest-icon">🚫</span>
                    What they avoid
                </label>
                <span className="negative-interest-count">
                    {negativeInterests.length}/{maxInterests}
                </span>
            </div>

            {/* Selected Negative Interests */}
            <div className="selected-negative-interests">
                {negativeInterests.map((interest, index) => (
                    <div key={index} className="negative-interest-tag">
                        <span className="negative-interest-text">{interest}</span>
                        <button
                            type="button"
                            className="negative-interest-remove"
                            onClick={() => removeInterest(interest)}
                            disabled={disabled}
                            aria-label={`Remove ${interest} from things to avoid`}
                        >
                            ✕
                        </button>
                    </div>
                ))}

                {/* Add Negative Interest Input */}
                {negativeInterests.length < maxInterests && (
                    <div className="add-negative-interest-container">
                        <input
                            type="text"
                            className="add-negative-interest-input"
                            placeholder="Type anything they avoid (e.g., plastic, loud things)..."
                            value={inputValue}
                            onChange={handleInputChange}
                            onKeyDown={handleInputKeyDown}
                            disabled={disabled}
                            aria-label="Add something to avoid"
                        />
                    </div>
                )}
            </div>

            {/* Helper Text */}
            <div className="negative-interest-helper">
                <span className="negative-helper-text">
                    Our AI will exclude products with these characteristics
                </span>
                {negativeInterests.length >= maxInterests && (
                    <span className="negative-max-reached-text">
                        Maximum exclusions reached
                    </span>
                )}
            </div>
        </div>
    );
};

export default NegativeInterestBuilder; 